
export const buildCoveragePolygons = async (vueInstance, coverageData) => {
    let self = vueInstance;

    const fillColors = [
        "#FF5733", // Red-Orange
        "#33FF57", // Lime Green
        "#5733FF", // Violet
        "#FF33A6", // Hot Pink
        "#33A6FF", // Sky Blue
        "#FF9A33", // Orange
        "#33FFF0", // Light Turquoise
        "#FF33D4", // Fuchsia
        "#FFB833", // Amber
        "#33FFB8", // Aquamarine
        "#B833FF", // Purple
        "#FF5733", // Coral
        "#33D4FF", // Light Blue
        "#FF8F33", // Pumpkin
        "#FF33FF"  // Magenta
    ];


    for(let [fIdx, data] of coverageData.entries()) {
        let feature = data.sector_feature_data
        let fillColor = fillColors[fIdx];
        if(feature.properties && feature.properties.COLOR && TELSA.isValidRGB(feature.properties.COLOR)) {
            fillColor = TELSA.convertRGBToHexColor(feature.properties.COLOR); // use the supplied color if its legit
        }

        let polygons = [];
        if(feature.geometry.type == 'GeometryCollection') {
            polygons = feature.geometry.geometries    
        }
        else if(feature.geometry.type == 'MultiPolygon') {
            polygons = [feature.geometry];
        }

        for(let [pIdx, polygon] of polygons.entries()) {
            let paths = [];
            //console.log('polygon: ', polygon);
            for(let coordinateSet of polygon.coordinates) {
                //console.log('coordinateSet: ', coordinateSet);
                coordinateSet = (feature.geometry.type == 'MultiPolygon') ? coordinateSet[0] : coordinateSet;
                let path = [];
                for(let point of coordinateSet) {
                    //path.push({lat: point[0], lng: point[1]});
                    //path.push(new google.maps.LatLng(point[0], point[1]));
                    //console.log(`${point[1]}, ${point[0]}`);
                    path.push(new google.maps.LatLng(point[1], point[0]));
                }   

                //console.log('path: ', path);
                let mapPolygon = new google.maps.Polygon({
                    id: `${feature.properties.LEGEND}_${pIdx}`,
                    sect_id: data.sect_id,
                    feature: feature.properties.LEGEND,
                    label: feature.properties.LEGEND,
                    paths: path,
                    map: self.googleMapsObj,
                    fillColor: fillColor,
                    fillOpacity: 0.4,
                    strokeColor: 'white',
                    strokeWeight: 1,
                    zIndex: 1
                });
                self.coveragePolygons.push(mapPolygon);
                //console.log('mapPolygon: ', mapPolygon);


                

                google.maps.event.addListener(mapPolygon, 'click', function(event) {
                    // console.log('click: ', event);
                    // console.log('mapPolygon: ', mapPolygon);
                    let featurePolygons = self.coveragePolygons.filter(p => p.feature == mapPolygon.feature);
                    // console.log('featurePolygons: ', featurePolygons);
                    featurePolygons.forEach(polygon => {
                        polygon.setOptions({strokeColor: 'black', opacity: 0.85});
                    });
                });


                google.maps.event.addListener(mapPolygon, 'mouseover', () => {
                    // console.log(mapPolygon);
                    let feature = mapPolygon.feature;

                    // set bottom label to feature
                    document.getElementById('active-view-name-text-container').style.display = "block";
                    document.getElementById('active-view-name-text-container').innerHTML = `
                        <span>${feature}</span>
                    `;
                    let width = document.getElementById('active-view-name-text-container').offsetWidth;
                    document.getElementById('active-view-name-text-container').style.marginLeft = `-${width / 2}px`;


                    let featurePolygons = self.coveragePolygons.filter(p => p.feature == mapPolygon.feature);
                    featurePolygons.forEach(polygon => {
                        polygon.setOptions({strokeColor: 'black', fillOpacity: 0.8, zIndex: 10});
                    });
                });
                
                google.maps.event.addListener(mapPolygon, 'mouseout', () => {
                    self.hideActiveMapViewNameText();

                    let featurePolygons = self.coveragePolygons.filter(p => p.feature == mapPolygon.feature);
                    featurePolygons.forEach(polygon => {
                        polygon.setOptions({strokeColor: 'white', fillOpacity: 0.4, zIndex: 1});
                    });
                });
                
            }
        }
        if(fIdx > 5) {
            return;
        }
    }
};




export const showCoverageData = async (vueInstance, sectorIds) => {
    let self = vueInstance;

    console.log('showCoverageData sectorIds: ', sectorIds);
    self.activeCoverageSectIds = self.activeCoverageSectIds.concat(sectorIds);
    for(let sectorId of sectorIds) {
        // check idb table for data
        let coverageData = await TELSA.IDB.getAllViaIndex('geoMapCoverageDataStore', 'sectorIdIndex', sectorId);
        buildCoveragePolygons(self, coverageData); // this takes an array
    }
};

export const hideCoverageData = async (vueInstance, sectorIds) => {
    let self = vueInstance;

    console.log('hideCoverageData sectorIds: ', sectorIds);
    self.activeCoverageSectIds = self.activeCoverageSectIds.filter(id => !sectorIds.includes(id)); // remove from list


    console.log('remove from self.coveragePolygons: ', self.coveragePolygons);

    for(let sect_id of sectorIds) {
        let removePolygons = self.coveragePolygons.filter(p => p.sect_id == sect_id);
        removePolygons.forEach(p => p.setMap(null));
        // remove coverage polygons
        self.coveragePolygons = self.coveragePolygons.filter(coverage => {
            // Check if the sect_id is not in removePolygons
            return !removePolygons.some(r => r.sect_id === coverage.sect_id);
        });
    }
    console.log('remove from self.coveragePolygons: ', self.coveragePolygons);
    
    
};




export const fetchCoverageData = async (vueInstance) => {
    let self = vueInstance;

    // first get a list of all coverageIds
    let route = `${TELSA.apiHost}geomap/coverage`;
    let sectorCoverageIds = (await self.$http.post(`${TELSA.apiHost}geomap/coverage`, {args: {}})).body;
    console.log('sectorCoverageIds: ', sectorCoverageIds);

    // now get a list of all the coverageIds we have in indexdb
    let localCoverageIds = await TELSA.IDB.getAllKeys('geoMapCoverageDataStore');
    console.log('localCoverageIds: ', localCoverageIds);

    // for each local coverage data, check if its outdated and build list of coverages we need to get
    let neededCoverageIds = [];
    neededCoverageIds = sectorCoverageIds.filter(item => !localCoverageIds.includes(item));
    let removeCoverageIds = localCoverageIds.filter(item => !sectorCoverageIds.includes(item)); // this is if we have anything locally that no longer exists in the database. i.e. they delted the sector.

    console.log('neededCoverageIds: ', neededCoverageIds);
    console.log('removeCoverageIds: ', removeCoverageIds);


    for(let id of neededCoverageIds) {
        let sectorCoverageData = (await self.$http.post(`${TELSA.apiHost}geomap/coverage`, {args: {requested_coverage_ids: [id]}})).body;
        console.log('sectorCoverageData: ', sectorCoverageData);
        // sectorCoverageData = JSON.parse(sectorCoverageData);
        // console.log('sectorCoverageData: ', sectorCoverageData);
        sectorCoverageData = sectorCoverageData[0];
        console.log('sectorCoverageData: ', sectorCoverageData);
        await TELSA.IDB.set('geoMapCoverageDataStore', id, sectorCoverageData);
    }

    // go delete the old ones
    for(let id of removeCoverageIds) {
        await TELSA.IDB.remove('geoMapCoverageDataStore', id);
    }
};
